import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "./app/hooks";
import AuthLayout from "./modules/auth/pages/AuthLayout";
import LoginView from "./modules/auth/pages/login/Index";
import { useScrollToTop } from "./hooks/useScrollToTop";
import LoadingScreen from "./components/shared-components/loading-screen";
import Router from "./modules/routes";
import { initSimpleAutoIdManager } from "./utils/autoIdManager";

function App() {
  useScrollToTop();
  const state = useAppSelector((state) => state.auth);
  const userMenus = useAppSelector((state) => state.userMenus);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const cleanup = initSimpleAutoIdManager("#root");
    return () => cleanup?.();
  }, []);

  useEffect(() => {
    if (state.isAuthenticated && state.user?.id != null) {
      try {
        localStorage.setItem("userId", String(state.user.id));
      } catch {
      }
    }
  }, [state.isAuthenticated, state.user?.id]);

  useEffect(() => {
    const menuPaths = userMenus.data?.map((m) => m.web_url) || [];
    const hasNurseMenu = !!userMenus.data?.some((m) =>
      (m.web_url || "").toLowerCase().includes("nurse/patient-list")
    );

    console.log("[RootRedirect] check", {
      isAuthenticated: state.isAuthenticated,
      loadingMenus: userMenus.loading,
      path: location.pathname,
      hasNurseMenu,
      user: state.user,
      menuPaths,
    });

    if (!state.isAuthenticated) return;
    if (userMenus.loading) return;
    if (location.pathname !== "/") return;

    if (hasNurseMenu) {
      console.log("[RootRedirect] navigating to /nurse/patient-list");
      navigate("/nurse/patient-list", { replace: true });
    }
  }, [state.isAuthenticated, userMenus.loading, userMenus.data, navigate, location.pathname]);

  return (
    <>
      {state.loading ? (
        <LoadingScreen />
      ) : state.isAuthenticated === true ? (
        <Router/>
      ) : (
        <AuthLayout>
          <LoginView />
        </AuthLayout>
      )}
    </>
  );
}

export default App;
